module.exports = __webpack_public_path__ + "img/emp-5.f1ba730e.jpeg";